<div class="component-container">
  <app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

  <div class="menu-container">
    <div class="grid-menu">
      @for (card of menuCards; track card.route) {
        <button
          mat-button
          color="primary"
          class="menu-item-btn"
          (click)="navigationTo(card.route)">
          <div class="button-content">
            <mat-icon class="menu-icon">{{ card.icon }}</mat-icon>
            <span class="menu-label">{{ card.title }}</span>
            <p class="menu-description">{{ card.description }}</p>
          </div>
        </button>
      }
      @if (loaded && menuCards.length === 0) {
        <p class="menu-description">Tu rol no tiene asignada ninguna opción de Auditoría.</p>
      }
    </div>
  </div>
</div>
